<template>
    <layout class="text-white">
        <!--Menu is loaded by the layout-->

        <!--Hero Section-->
        <section class="static-page-hero bg-black-700 full-width relative phone:h-screen tablet:h-full flex flex-col">
            <background-image
                :src="src"
                :srcset="imgSrcSet" />

            <div
                class="container flex phone:flex-col phone:justify-center flex-grow z-10 pt-8 tablet:pt-16 pb-16 tablet:items-center">
                <!--Layout Spacer -- Matches Aside Text Component sizing/spacing-->
                <div class="hidden tablet:flex w-1/4 max-w-xxs mr-10 desktop:mr-32"></div>

                <!--Content Block  -->
                <div class="hero-text flex flex-col items-start phone:ml-20">
                    <!--Hero Content Text Component-->
                    <content-text>
                        <template #title-text>
                            <h2
                                v-if="page.primary_heading"
                                class="font-bold"
                                v-text="page.primary_heading" />
                        </template>
                        <template #subtitle-text>
                            <h2
                                v-if="page.secondary_heading"
                                class="font-light mb-6"
                                v-text="page.secondary_heading" />
                        </template>
                    </content-text>
                    <!--Hero Quote-->
                    <div class="max-w-xl phone:mt-6 tablet:mt-12 relative">
                        <svg-icon
                            icon="quotes"
                            class="quotes-icon absolute w-3 left-neg top-1" />
                        <blockquote
                            v-if="page.quote"
                            class="border-l pl-2 font-bold-italic"
                            v-text="page.quote" />
                        <div
                            v-if="page.quote_attribution"
                            class="uppercase font-bold mt-5 ml-2"
                            v-text="page.quote_attribution" />
                    </div>
                </div>
            </div>
        </section>

        <!--Content Section-->
        <section
            class="bg-black-700 full-width pb-14 desktop:pb-32">
            <div class="container flex flex-col desktop:flex-row phone:items-start -mt-32 tablet:-mt-16">
                <!--Last Modified - side text component-->
                <div class="last-modified phone:w-1/2 tablet:w-1/4 max-w-xxs mb-14 z-20 desktop:mr-8">
                    <hr class="text-gold-500">
                    <div class="text-base uppercase tracking-wide pt-4 pb-2">
                        <span>{{ labels.last_updated_label }}</span>
                    </div>
                    <div class="uppercase tracking-wide leading-normal text-gold-500">
                        <span
                            v-if="page.formatted_last_updated_at"
                            v-text="page.formatted_last_updated_at"></span>
                    </div>
                </div>
                <!--Page Content-->
                <div class="text-gray-700 max-w-4xl z-20 desktop:-mt-28">
                    <div class="bg-white phone:px-12 phone:py-10 tablet:p-24">
                        <h3
                            class="uppercase text-gold-500 tracking-wide mb-3 font-bold"
                            v-text="page.name" />
                        <div v-html="page.content" />
                        <div class="mt-12">
                            <hr class="text-gold-500 w-12 mb-4">
                            <div class="flex">
                                <div class="font-italic mr-2">
                                    {{ labels.questions_label }}?
                                </div>
                                <tis-button
                                    class="btn-flat text-sm group transition-transform"
                                    :url="route('web.contact')">
                                    {{ labels.questions_button_label }}
                                    <svg-icon
                                        icon="arrow-horizontal"
                                        class="w-6 h-6 inline-block ml-2 transition-transform transform duration-200 group-hover:translate-x-1" />
                                </tis-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--Instagram section-->
        <!-- <section-instagram
            :section-instagram="sectionInstagram"
            :external-links="$page.externalLinks"></section-instagram> -->

        <!--Footer is loaded by the layout-->
    </layout>
</template>

<script>
import Layout from '@web/components/PageLayout';
import BackgroundImage from '@web/components/BackgroundImage';
import ContentText from '@web/components/ContentText';
// import SectionInstagram from '@web/pages/sections/shared/SectionInstagram';
import SvgIcon from '@whisper/components/icons/SvgIcon';
import TisButton from '@whisper/components/buttons/TisButton';

export default {
  components: {
    Layout,
    BackgroundImage,
    ContentText,
    SvgIcon,
    // SectionInstagram,
    TisButton,
  },
  props: {
    // Page Specific Props from StaticPageController.php
    page: {
      type: Object,
      required: true,
      default: () => ({
        primary_heading: 'Privacy Matters',
        secondary_heading: 'Please read below',
        quote: 'Their transparency and constant communication allow me to focus on other business related things.',
        quote_attribution: 'Nordica',
      }),
    },
    // Shared Props from WebsiteSharedProps.php
    sectionInstagram: {
      type: Object,
      required: true,
    },
    labels: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    src: '/img/web/static-page-bg-1024.jpg',
    imgSrcSet: '/img/web/static-page-bg-480.jpg 480w, '
      + '/img/web/static-page-bg-1024.jpg 1024w, '
      + '/img/web/static-page-bg-1920.jpg 1920w, '
      + '/img/web/static-page-bg-3440.jpg 3440w ',
  }),
};
</script>
